import { _enum, array, schema } from "@anna-money/anna-web-lib/serializer";

export enum ConsentType {
  ConfirmationStatement = "CONFIRMATION_STATEMENT",
  ActAsDirector = "ACT_AS_DIRECTOR",
  ActAsShareholder = "ACT_AS_SHAREHOLDER",
  AnnaTerms = "ANNA_TERMS",
  CustomerAgreement = "CUSTOMER_AGREEMENT",
  PrivacyPolicy = "PRIVACY_POLICY",
  // AU
  AuComplianceStatement = "AU_COMPLIANCE_STATEMENT",
  AuPremisesConsentStatement = "AU_PREMISES_CONSENT_STATEMENT",
  AcspIdentityVerification = "ACSP_IDENTITY_VERIFICATION",
}

export class ConsentData extends schema(
  {
    items: array(_enum(ConsentType, "ConsentType")),
  },
  "ConsentData",
) {}
